/**
 * Created by Christal on 2018/5/14.
 */
import Env from './env'
import axios from 'axios'
import store from '../store/state'
import { MessageBox } from 'element-ui'
import router from '../router/index'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = true;

// 添加一个请求拦截器
axios.interceptors.request.use(function (config) {
  if (store.token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.Authorization = store.token
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// 添加一个返回拦截器
axios.interceptors.response.use(response => {
  // 对返回的数据进行一些处理
  return response
}, error => {
  // 对返回的错误进行一些处理
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        MessageBox.alert('登录过期，请重新登陆', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            router.push('/')
            localStorage.clear()
            window.location.reload()
          }
        })
        break;
      default :
        this.$message.error('系统错误: ', error.response.msg)
    }
  }
  return Promise.reject(error)
})

// 基地址
let base = Env.baseURL

// 通用方法
export const POST = (url, params, config) => {
  return axios.post(`${base}${url}`, params, config).then(res => res.data)
}

export const POSTJSON = (url, params) => {
  console.log('==%S', params)
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {'Content-Type': 'application/json'}
  }).then(res => res.data)
}

export const GET = (url, params) => {
  return axios.get(`${base}${url}`, {
    params: params
  }).then(res => res.data)
}

export const PUT = (url, params) => {
  return axios.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
  return axios.delete(`${base}${url}/` + params).then(res => res.data)
}

export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js